import React, { useContext, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import {
  TopNavContainer,
  NavGridContainer,
  GridItemContainer,
  AppLogo,
  MenuDrawer,
  TranslateOption,
  UserNameText,
  ListItem,
} from './styles';
import LogOutModal from '../../components/Modals/LogOutModal';
import { ENABLE_TOLGEE, ENTERPRISE_ENV } from '../../utils/helper';
import MultipleFileUploadModal from '../../components/Modals/MultipleFileUploadModal';
import { AppStoreContext } from '../../context/appStoreContext';
import { ChangePasswordModal } from '../../components/Modals';
import BillingPassword from '../../components/Modals/BillingPassword';
import { ENABLE_INSPIRATIONS, ENABLE_EMAIL_DESIGNS, EMAIL_REVAMP } from '../../utils/helper';
import Changelang from './Changelanguage';
import { removeDuplicateFirstNames } from '../../utils/javascript';
import { NAVIGATION_MENUS } from './translationValues';
import CustomTooltip from '../../components/CustomTooltip/CustomTooltip';
import { AppTourContext } from '../../context/appTourContext';
import SideNavButton from './SideNavButton';
import ChangelangTolgee from './ChangeLanguageTolgee';
import ImageWithFallback from '../../components/ImageWithFallback/ImageWithFallback';
import { getTrackingAccessToken } from '../../utils/services/authAPI';
import { APP_VERSION } from '../../utils/helper';
const NAMESPACES = ['NAVIGATION_MENUS'];

const SideNav = props => {
  const { t } = props;
  const { loginVisible, checkUserAccess, checkUserAccessRoles, userDetails, isEnterprise, setFetchingCategories, ssoSetup, licenseDetails } = useContext(AppStoreContext);
  const { tourSkipped } = useContext(AppTourContext);
  const [drawVisible, setDrawVisible] = useState(false);
  const [drawAnimate, setDrawAnimate] = useState(false);
  const [modalVisibility, setmodalVisibility] = useState(false);
  const [ModalVisibility, setModalVisibility] = useState(false);
  const [openPassword, setOpenPassword] = useState(false);
  const [subNavAnimate, setSubNavAnimate] = useState(true);
  const [subNav, setSubNav] = useState(false);
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [subNavList, setSubNavList] = useState([]);
  const [userNameHover, setUserNameHover] = useState(false);

  const { displayName, firstName, lastName,planMapping } = userDetails;
  const userName = removeDuplicateFirstNames(displayName) || ((firstName || lastName) && `${firstName.trim()} ${lastName !== null ? lastName : ''}`);

  const showDraw = () => {
    setDrawVisible(true);
  };
  let history = useHistory();
  let currentLocation = useLocation();
  const hideDraw = () => {
    setSubNav(false);
    setDrawVisible(false);
    setDrawAnimate(true);
    setTimeout(() => {
      setDrawAnimate(false);
    }, 0); //1800
  };
  const redirectTo = e => {
    hideDraw();
    setTimeout(() => {
      if (e.includes('documentTemplates') || e.includes('shortMessageTemplates')) {
        if(e !== currentLocation.pathname)
        setFetchingCategories(true);
      }
      history.push(`${e}`);
    }, 1000);
  };

  const logOutUser = () => {
    hideDraw();
    setModalVisibility(true);
  };

  const togglePasswordModal = () => {
    hideDraw();
    setOpenPassword(true);
  };

  const navigateToWorkflow = async () => {
    const path = licenseDetails?.workFlowUrl;
    let redirectPath;
    if(!localStorage.getItem('sso_signIn')) {
      const response = await getTrackingAccessToken();
      if(response?.statusCode === 4002) {
        redirectPath = `${path}/pds-redirect?token=${response?.data}`;
      }
    } else {
      redirectPath = `${path}${ssoSetup?.ssoEnabled ? '/sso' : ''}`;
    }
    window.open(redirectPath, '_blank');
  };

  const accountDetailsSubNavList = [
      !isEnterprise &&
        checkUserAccessRoles(['ADMIN']) && {
          title: t(
            NAVIGATION_MENUS.BILLING_AND_INVOICE_MENU.key,
            NAVIGATION_MENUS.BILLING_AND_INVOICE_MENU.value,
          ),
          showBillingModal: true,
          desc: t(
            NAVIGATION_MENUS.BILLING_AND_INVOICE_MENU_DESCRIPTION.key,
            NAVIGATION_MENUS.BILLING_AND_INVOICE_MENU_DESCRIPTION.value,
          ),
        },
      !isEnterprise && {
        title: t(NAVIGATION_MENUS.USAGE_MENU_TITLE.key, NAVIGATION_MENUS.USAGE_MENU_TITLE.value),
        redirectTo: '/planUsage',
        desc: t(
          NAVIGATION_MENUS.USAGE_MENU_DESCRIPTION.key,
          NAVIGATION_MENUS.USAGE_MENU_DESCRIPTION.value,
        ),
      },
      checkUserAccessRoles(['ADMIN']) && {
        title: t(
          NAVIGATION_MENUS.INTEGRATION_KEY_MENU_TITLE.key,
          NAVIGATION_MENUS.INTEGRATION_KEY_MENU_TITLE.value,
        ),
        redirectTo: '/integrationKey',
        desc: t(
          NAVIGATION_MENUS.INTEGRATION_KEY_MENU_DESCRIPTION.key,
          NAVIGATION_MENUS.INTEGRATION_KEY_MENU_DESCRIPTION.value,
        ),
      },
    ].filter(v => !!v);

  return (
    <TopNavContainer>
      <MenuDrawer
        className={
          drawVisible
            ? !subNavAnimate
              ? 'drawVisible removeAnimation'
              : 'drawVisible'
            : drawAnimate
            ? 'drawAnimate'
            : 'drawInVisible'
        }
        onMouseLeave={() => setSubNav(false)}
      >
        <div className={!drawVisible ? 'switch' : 'switch_test'} />
        <div className="box">
          <div className="menus">
          <TranslateOption onMouseOver={() => setSubNav(false)}>
             {ENABLE_TOLGEE ? <ChangelangTolgee /> : <Changelang />} 
          </TranslateOption>
          {!loginVisible && (
            <>
              {userName && (
                <UserNameText
                drawVisible={drawVisible}
                onMouseOver={() => setUserNameHover(true)}
                onMouseLeave={() => setUserNameHover(false)}
                isHovered={userNameHover}>
                  <h2 className='full-name'>{userName}</h2>
                  <h2 className='initial'>{userName.charAt(0)}</h2>
                  <ul>
                    {Array.from({ length: 12 }, (_, index) => (
                      <ListItem key={index} drawVisible={drawVisible} isHovered={userNameHover} rotate={index*30}></ListItem>
                    ))}
                  </ul>
                </UserNameText>
              )}
              {checkUserAccess('master', ['DESIGNER']) && (
                <div
                  className="option"
                  onMouseOver={() => {
                    setSubNav(false);
                  }}
                  onClick={() => {
                    setmodalVisibility(true);
                  }}
                >
                  {t(NAVIGATION_MENUS.ASSET_UPLOADS_MENU.key, NAVIGATION_MENUS.ASSET_UPLOADS_MENU.value)}
                  <div className="arrow" />
                </div>
              )}
                    <div
                      className="option"
                      onMouseOver={() => {
                        setSubNav(true);
                        setSubNavAnimate(false);
                        setTimeout(() => {
                          setSubNavAnimate(true);
                        }, 20);
                        setSubNavList([
                          {
                            title: t(
                              NAVIGATION_MENUS.DOCUMENT_MENU_TITLE.key,
                              NAVIGATION_MENUS.DOCUMENT_MENU_TITLE.value,
                            ),
                            redirectTo: '/documentDashboard',
                            desc: t(
                              NAVIGATION_MENUS.DOCUMENT_DASHBOARD_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.DOCUMENT_DASHBOARD_MENU_DESCRIPTION.value,
                            ),
                          },
                          ENABLE_EMAIL_DESIGNS && {
                            title: t(
                              NAVIGATION_MENUS.EMAIL_MENU_TITLE.key,
                              NAVIGATION_MENUS.EMAIL_MENU_TITLE.value,
                            ),
                            redirectTo: EMAIL_REVAMP ? '/complexEmailDashboard' : '/emailDashboard',
                            desc: t(
                              NAVIGATION_MENUS.EMAIL_DASHBOARD_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.EMAIL_DASHBOARD_MENU_DESCRIPTION.value,
                            ),
                          },
                          isEnterprise && {
                            title: t(
                              NAVIGATION_MENUS.SHORT_MESSAGE_MENU_TITLE.key,
                              NAVIGATION_MENUS.SHORT_MESSAGE_MENU_TITLE.value,
                            ),
                            redirectTo: '/shortMessageDashboard',
                            desc: t(
                              NAVIGATION_MENUS.SHORT_MESSAGE_DASHBOARD_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.SHORT_MESSAGE_DASHBOARD_MENU_DESCRIPTION.value,
                            ),
                          },
                          checkUserAccessRoles(['ADMIN', 'DESIGNER', 'PUBLISHER', 'JOBMANAGER', 'JOBAPPROVERL1', 'JOBAPPROVERL2', 'JOBAPPROVERL3', 'JOBAPPROVERL4']) && {
                            title: t(
                              NAVIGATION_MENUS.JOB_MONITORING_TITLE.key, 
                              NAVIGATION_MENUS.JOB_MONITORING_TITLE.value
                            ),
                            desc: t(
                              NAVIGATION_MENUS.STATUS_MONITORING_DESCRIPTION.key, 
                              NAVIGATION_MENUS.STATUS_MONITORING_DESCRIPTION.value
                            ),
                            redirectTo: '/statusMonitoring',
                          },
                        ]);
                      }}
                    >
                      {t(NAVIGATION_MENUS.DASHBOARD_MENU.key, NAVIGATION_MENUS.DASHBOARD_MENU.value)}
                      <div className="arrow" />
                    </div>
                {checkUserAccessRoles(['DESIGNER', 'PUBLISHER', 'EDITOR', 'REUSABLECONTENTMANAGER']) && (
                    <div
                      className="option"
                      onMouseOver={() => {
                        setSubNav(true);
                        setSubNavAnimate(false);
                        setTimeout(() => {
                          setSubNavAnimate(true);
                        }, 20);
                        setSubNavList([
                          ENABLE_INSPIRATIONS && {
                            title: t(
                              NAVIGATION_MENUS.DESIGN_INSPIRATION_MENU_TITLE.key,
                              NAVIGATION_MENUS.DESIGN_INSPIRATION_MENU_TITLE.value,
                            ),
                            redirectTo: '/designInspirations',
                            desc: t(
                              NAVIGATION_MENUS.DESIGN_INSPIRATION_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.DESIGN_INSPIRATION_MENU_DESCRIPTION.value,
                            ),
                          },
                          {
                            title: t(
                              NAVIGATION_MENUS.DOCUMENT_MENU_TITLE.key,
                              NAVIGATION_MENUS.DOCUMENT_MENU_TITLE.value,
                            ),
                            redirectTo: '/documentTemplates',
                            desc: t(
                              NAVIGATION_MENUS.DOCUMENT_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.DOCUMENT_MENU_DESCRIPTION.value,
                            ),
                          },
                          ENABLE_EMAIL_DESIGNS && {
                            title: t(
                              NAVIGATION_MENUS.EMAIL_MENU_TITLE.key,
                              NAVIGATION_MENUS.EMAIL_MENU_TITLE.value,
                            ),
                            redirectTo: EMAIL_REVAMP ? '/complexEmailTemplates' : '/emailTemplates',
                            desc: t(
                              NAVIGATION_MENUS.EMAIL_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.EMAIL_MENU_DESCRIPTION.value,
                            ),
                          },
                          isEnterprise && checkUserAccessRoles(['DESIGNER', 'PUBLISHER']) && {
                            title: t(
                              NAVIGATION_MENUS.SHORT_MESSAGE_MENU_TITLE.key,
                              NAVIGATION_MENUS.SHORT_MESSAGE_MENU_TITLE.value,
                            ),
                            redirectTo: '/shortMessageTemplates',
                            desc: t(
                              NAVIGATION_MENUS.SHORT_MESSAGE_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.SHORT_MESSAGE_MENU_DESCRIPTION.value,
                            ),
                          },
                          (isEnterprise && checkUserAccessRoles(['EDITOR'])) && {
                            title: t(
                              NAVIGATION_MENUS.INTERACTIVE_DOCUMENTS_MENU_TITLE.key,
                              NAVIGATION_MENUS.INTERACTIVE_DOCUMENTS_MENU_TITLE.value,
                            ),
                            redirectTo: '/interactiveTemplates',
                            desc: t(
                              NAVIGATION_MENUS.INTERACTIVE_DOCUMENTS_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.INTERACTIVE_DOCUMENTS_MENU_DESCRIPTION.value,
                            ),
                          }
                        ]);
                      }}
                    >
                      {t(
                        NAVIGATION_MENUS.DESIGN_SYSTEM_MENU_TITLE.key,
                        NAVIGATION_MENUS.DESIGN_SYSTEM_MENU_TITLE.value,
                      )}
                      <div className="arrow" />
                    </div>
                  )}
                {checkUserAccessRoles(['DESIGNER', 'PUBLISHER']) && (
                    <div
                      className="option"
                      onMouseOver={() => {
                        setSubNav(true);
                        setSubNavAnimate(false);
                        setTimeout(() => {
                          setSubNavAnimate(true);
                        }, 20);
                        setSubNavList([
                          {
                            title: t(
                              NAVIGATION_MENUS.GENERATE_PDF_MENU_TITLE.key,
                              NAVIGATION_MENUS.GENERATE_PDF_MENU_TITLE.value,
                            ),
                            redirectTo: '/publishedTemplates',
                            desc: t(
                              NAVIGATION_MENUS.GENERATE_PDF_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.GENERATE_PDF_MENU_DESCRIPTION.value,
                            ),
                          },
                          ENABLE_EMAIL_DESIGNS && {
                            title: t(
                              NAVIGATION_MENUS.TRIGGER_EMAIL_MENU_TITLE.key,
                              NAVIGATION_MENUS.TRIGGER_EMAIL_MENU_TITLE.value,
                            ),
                            redirectTo: EMAIL_REVAMP ? '/complexEmailPublishedTemplates' : '/emailPublishedTemplates',
                            desc: t(
                              NAVIGATION_MENUS.TRIGGER_EMAIL_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.TRIGGER_EMAIL_MENU_DESCRIPTION.value,
                            ),
                          },
                          isEnterprise && {
                            title: t(
                              NAVIGATION_MENUS.SEND_WHATSAPP_MENU_TITLE.key,
                              NAVIGATION_MENUS.SEND_WHATSAPP_MENU_TITLE.value,
                            ),
                            redirectTo: '/publishedMessages',
                            desc: t(
                              NAVIGATION_MENUS.SEND_WHATSAPP_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.SEND_WHATSAPP_MENU_DESCRIPTION.value,
                            ),
                          },
                          isEnterprise && {
                            title: t(
                              NAVIGATION_MENUS.SEND_SMS_MENU_TITLE.key,
                              NAVIGATION_MENUS.SEND_SMS_MENU_TITLE.value,
                            ),
                            redirectTo: '/publishedSMS',
                            desc: t(
                              NAVIGATION_MENUS.SEND_SMS_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.SEND_SMS_MENU_DESCRIPTION.value,
                            ),
                          },
                          isEnterprise && {
                            title: t(
                              NAVIGATION_MENUS.INITIATE_CALL_MENU_TITLE.key,
                              NAVIGATION_MENUS.INITIATE_CALL_MENU_TITLE.value,
                            ),
                            redirectTo: '/publishedCallMessages',
                            desc: t(
                              NAVIGATION_MENUS.INITIATE_CALL_MENU_DESCRIPTION.key,
                              NAVIGATION_MENUS.INITIATE_CALL_MENU_DESCRIPTION.value,
                            ),
                          },
                        ]);
                      }}
                    >
                      {t(NAVIGATION_MENUS.TRANSACTIONS_MENU.key, NAVIGATION_MENUS.TRANSACTIONS_MENU.value)}
                      <div className="arrow" />
                    </div>
                  )}
               {checkUserAccessRoles(['ADMIN', 'MAILROOMADMIN']) && (
                <div
                  className="option settings"
                  onMouseOver={() => {
                    setSubNav(false);
                  }}
                  onClick={() => redirectTo('/user/account-settings')}
                >
                  {t(NAVIGATION_MENUS.ADMIN_CONFIGURATION_MENU.key, NAVIGATION_MENUS.ADMIN_CONFIGURATION_MENU.value)}
                  <div className="arrow" />
                </div>
              )}
                {accountDetailsSubNavList.length > 0 ? <div
                   className="option settings"
                  onMouseOver={() => {
                    setSubNav(true);
                    setSubNavAnimate(false);
                    setTimeout(() => {
                      setSubNavAnimate(true);
                    }, 20);
                    setSubNavList(accountDetailsSubNavList);
                  }}
                >
                  {t(NAVIGATION_MENUS.ACCOUNT_DETAILS_MENU_TITLE.key, NAVIGATION_MENUS.ACCOUNT_DETAILS_MENU_TITLE.value)}                   
                  <div className="arrow" />
                </div> : null}
              {isEnterprise && checkUserAccessRoles(['MAILROOMADMIN', 'MAILROOMCLIENT']) && (
                  <div
                    className="option"
                    onMouseOver={() => {
                      setSubNav(false);
                    }}
                    onClick={() => redirectTo('/mailRoom')}
                  >
                    {t(NAVIGATION_MENUS.MAIL_ROOM_MENU.key, NAVIGATION_MENUS.MAIL_ROOM_MENU.value)}
                    <div className="arrow" />
                  </div>
                )}
              {checkUserAccessRoles(['DESIGNER', 'PUBLISHER', 'REUSABLECONTENTMANAGER']) && (
                  <div
                    className="option variables"
                    onMouseOver={() => {
                      setSubNav(false);
                    }}
                    onClick={() => redirectTo('/manageVariables')}
                  >
                    {t(
                      NAVIGATION_MENUS.MANAGE_DATA_VARIABLES_MENU.key,
                      NAVIGATION_MENUS.MANAGE_DATA_VARIABLES_MENU.value,
                    )}
                    <div className="arrow" />
                  </div>
                )}
              {checkUserAccessRoles(['ADMIN', 'DESIGNER', 'PUBLISHER']) && <div
                  className="option variables"
                  onMouseOver={() => {
                    setSubNav(false);
                  }}
                  onClick={() => redirectTo('/generatedDocuments')}
                >
                  {t(
                    NAVIGATION_MENUS.CLEAN_UP_STORAGE_MENU.key,
                    NAVIGATION_MENUS.CLEAN_UP_STORAGE_MENU.value,
                  )}
                  <div className="arrow" />
                </div>}
              {ENTERPRISE_ENV &&
                checkUserAccessRoles(['WORKFLOW']) &&
                !!licenseDetails?.workFlowUrl ? (
                  <div
                    className="option"
                    onMouseOver={() => {
                      setSubNav(false);
                    }}
                    onClick={navigateToWorkflow}
                  >
                    {t(NAVIGATION_MENUS.WORKFLOW_MENU.key, NAVIGATION_MENUS.WORKFLOW_MENU.value)}
                    <div className="arrow" />
                  </div>
                ) : null}
              {planMapping?.planName !== 'Free' && (
                 <div
                   className="option"
                   onMouseOver={() => {
                     setSubNav(false);
                   }}
                   onClick={() => redirectTo('/support')}
                 >
                   {t(NAVIGATION_MENUS.SUPPORT_MENU.key, NAVIGATION_MENUS.SUPPORT_MENU.value)}
                   <div className="arrow" />
                 </div>
               )}
                <div
                  className="option"
                  onMouseOver={() => {
                    setSubNav(false);
                  }}
                  onClick={togglePasswordModal}
                >
                  {t(
                    NAVIGATION_MENUS.CHANGE_PASSWORD_MENU.key,
                    NAVIGATION_MENUS.CHANGE_PASSWORD_MENU.value,
                  )}
                  <div className="arrow" />
                </div>
              </>
            )}
              <div
                className="option"
                onMouseOver={() => {
                  setSubNav(false);
                }}
                onClick={logOutUser}
              >
                {t(NAVIGATION_MENUS.LOGOUT_MENU.key, NAVIGATION_MENUS.LOGOUT_MENU.value)}
                <div className="arrow" />
              </div>
          </div>
        </div>
        <div
          className={subNav ? 'menus SubNav fade' : !subNav ? 'menus SubNav slide-left-delay' : ''}
        >
          <div className={subNav ? 'Layer slide-right' : !subNav ? 'Layer slide-left' : ''}></div>
          {subNavList.map((item, index) => {
            return (
              <>
                <div
                  className="subMenuOption"
                  key={index}
                  onClick={() => {
                    item.showBillingModal && setShowBillingModal(true)
                    setSubNav(false);
                    item.redirectTo && redirectTo(item.redirectTo);
                  }}
                >
                  <span>{item.title}</span> <div className="arrow" />
                </div>
                <p className="Description">{item.desc}</p>
              </>
            );
          })}
        </div>
      </MenuDrawer>
      <NavGridContainer>
        <GridItemContainer>
          <Link to={'/'}>
            <AppLogo>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="30pt"
                height="30.000001pt"
                viewBox="0 0 30 30.000001"
              >
                <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop
                    offset="0%"
                    style={{
                      stopColor: '#ef9d43',
                      stopOpacity: 1,
                    }}
                  />
                  <stop
                    offset="100%"
                    style={{
                      stopColor: '#e75516',
                      stopOpacity: 1,
                    }}
                  />
                </linearGradient>
                <g id="surface1">
                  <g clipPath="url(#clip1)" clipRule="nonzero">
                    <path
                      style={{
                        stroke: 'none',
                        fillRule: 'nonzero',
                        fill: 'transparent',
                        fillOpacity: 1,
                      }}
                      d="M 0.484375 0 L 29.515625 0 L 29.515625 36.289062 L 0.484375 36.289062 Z M 0.484375 0 "
                    />
                    <path
                      style={{
                        stroke: 'none',
                        fillRule: 'nonzero',
                        fill: 'transparent',
                        fillOpacity: 1,
                      }}
                      d="M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 "
                    />
                    <path
                      style={{
                        stroke: 'none',
                        fillRule: 'nonzero',
                        fill: 'transparent',
                        fillOpacity: 1,
                      }}
                      d="M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 "
                    />
                  </g>
                  <path
                    style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#fff',
                      fillOpacity: 1,
                    }}
                    d="M 26.8125 12.125 C 26.734375 12.234375 26.621094 12.371094 26.5625 12.429688 C 26.375 12.617188 25.976562 12.929688 25.914062 12.929688 C 25.878906 12.929688 25.855469 12.945312 25.855469 12.96875 C 25.855469 12.988281 25.789062 13.03125 25.710938 13.058594 C 25.632812 13.085938 25.5625 13.125 25.5625 13.144531 C 25.5625 13.164062 25.453125 13.199219 25.320312 13.226562 C 25.179688 13.253906 25.078125 13.292969 25.085938 13.308594 C 25.109375 13.339844 24.566406 13.429688 24.140625 13.457031 L 23.816406 13.480469 L 23.816406 16.382812 L 14.765625 16.382812 C 9.382812 16.382812 5.6875 16.398438 5.640625 16.421875 C 5.601562 16.441406 5.460938 16.480469 5.332031 16.507812 C 5.203125 16.53125 5.019531 16.589844 4.929688 16.636719 C 4.835938 16.679688 4.742188 16.714844 4.714844 16.714844 C 4.695312 16.714844 4.675781 16.734375 4.675781 16.753906 C 4.675781 16.773438 4.632812 16.800781 4.578125 16.816406 C 4.523438 16.828125 4.441406 16.871094 4.390625 16.910156 C 4.339844 16.953125 4.242188 17.03125 4.171875 17.089844 C 4.058594 17.179688 3.902344 17.335938 3.695312 17.566406 C 3.605469 17.664062 3.425781 17.953125 3.425781 17.992188 C 3.425781 18.019531 3.402344 18.058594 3.367188 18.085938 C 3.335938 18.113281 3.292969 18.195312 3.28125 18.261719 C 3.265625 18.328125 3.238281 18.378906 3.21875 18.378906 C 3.203125 18.378906 3.15625 18.542969 3.117188 18.742188 C 3.019531 19.285156 3.019531 23.886719 3.117188 24.363281 C 3.15625 24.539062 3.199219 24.695312 3.21875 24.707031 C 3.234375 24.71875 3.265625 24.785156 3.277344 24.859375 C 3.292969 24.929688 3.335938 25.015625 3.367188 25.042969 C 3.402344 25.066406 3.425781 25.113281 3.425781 25.140625 C 3.425781 25.335938 4.300781 26.214844 4.582031 26.304688 C 4.632812 26.320312 4.675781 26.351562 4.675781 26.367188 C 4.675781 26.386719 4.757812 26.425781 4.863281 26.453125 C 4.964844 26.484375 5.050781 26.519531 5.050781 26.535156 C 5.050781 26.554688 5.203125 26.597656 5.394531 26.636719 C 5.703125 26.699219 6.59375 26.703125 15.0625 26.703125 C 23.496094 26.703125 24.421875 26.695312 24.714844 26.636719 C 24.898438 26.597656 25.050781 26.554688 25.066406 26.535156 C 25.078125 26.519531 25.160156 26.484375 25.253906 26.453125 C 25.34375 26.425781 25.425781 26.386719 25.441406 26.375 C 25.453125 26.359375 25.5625 26.277344 25.691406 26.195312 C 26.027344 25.976562 26.5625 25.425781 26.5625 25.296875 C 26.5625 25.273438 26.578125 25.246094 26.597656 25.246094 C 26.617188 25.246094 26.699219 25.101562 26.785156 24.921875 C 27.070312 24.300781 27.0625 24.550781 27.0625 17.898438 C 27.0625 13.148438 27.050781 11.929688 27.011719 11.929688 C 26.984375 11.929688 26.890625 12.023438 26.8125 12.125 Z M 23.476562 19.574219 C 23.484375 19.605469 23.511719 19.628906 23.542969 19.628906 C 23.628906 19.628906 23.8125 19.855469 23.839844 19.996094 C 23.859375 20.070312 23.886719 20.140625 23.902344 20.152344 C 23.953125 20.183594 23.953125 22.816406 23.902344 22.910156 C 23.882812 22.945312 23.839844 23.039062 23.816406 23.109375 C 23.792969 23.183594 23.714844 23.292969 23.648438 23.355469 C 23.492188 23.503906 23.15625 23.539062 21.988281 23.53125 C 21.496094 23.527344 17.863281 23.511719 13.914062 23.5 L 6.734375 23.476562 L 6.613281 23.386719 C 6.550781 23.335938 6.457031 23.222656 6.410156 23.136719 C 6.324219 22.984375 6.320312 22.941406 6.320312 21.488281 C 6.320312 20.542969 6.335938 19.992188 6.359375 19.96875 C 6.386719 19.953125 6.429688 19.886719 6.464844 19.820312 C 6.496094 19.753906 6.566406 19.683594 6.617188 19.660156 C 6.671875 19.632812 6.714844 19.601562 6.714844 19.582031 C 6.714844 19.566406 6.753906 19.542969 6.808594 19.535156 C 6.859375 19.523438 10.625 19.515625 15.179688 19.519531 C 21.761719 19.523438 23.457031 19.539062 23.476562 19.574219 Z M 23.476562 19.574219 "
                  />
                  <path
                    style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#fff',
                      fillOpacity: 1,
                    }}
                    d="M 3.210938 16.976562 C 3.289062 16.871094 3.402344 16.734375 3.460938 16.675781 C 3.648438 16.488281 4.046875 16.175781 4.109375 16.175781 C 4.140625 16.175781 4.167969 16.160156 4.167969 16.136719 C 4.167969 16.117188 4.234375 16.074219 4.3125 16.046875 C 4.390625 16.015625 4.457031 15.980469 4.457031 15.957031 C 4.457031 15.941406 4.570312 15.90625 4.703125 15.878906 C 4.839844 15.851562 4.945312 15.8125 4.9375 15.796875 C 4.910156 15.761719 5.457031 15.675781 5.882812 15.648438 L 6.207031 15.625 L 6.207031 12.722656 L 15.257812 12.722656 C 20.640625 12.722656 24.335938 12.703125 24.382812 12.683594 C 24.421875 12.664062 24.5625 12.625 24.691406 12.597656 C 24.820312 12.570312 25.003906 12.511719 25.09375 12.46875 C 25.1875 12.425781 25.28125 12.386719 25.304688 12.386719 C 25.328125 12.386719 25.347656 12.371094 25.347656 12.351562 C 25.347656 12.332031 25.390625 12.304688 25.445312 12.289062 C 25.496094 12.277344 25.582031 12.234375 25.632812 12.191406 C 25.679688 12.152344 25.78125 12.074219 25.851562 12.015625 C 25.964844 11.925781 26.121094 11.769531 26.324219 11.539062 C 26.417969 11.441406 26.597656 11.152344 26.597656 11.109375 C 26.597656 11.085938 26.621094 11.042969 26.65625 11.019531 C 26.6875 10.992188 26.730469 10.910156 26.742188 10.84375 C 26.757812 10.777344 26.785156 10.722656 26.804688 10.722656 C 26.820312 10.722656 26.867188 10.5625 26.902344 10.363281 C 27.003906 9.820312 27.003906 5.21875 26.902344 4.738281 C 26.867188 4.566406 26.824219 4.410156 26.804688 4.398438 C 26.789062 4.386719 26.757812 4.320312 26.746094 4.246094 C 26.730469 4.175781 26.6875 4.089844 26.65625 4.0625 C 26.621094 4.035156 26.597656 3.992188 26.597656 3.964844 C 26.597656 3.769531 25.722656 2.886719 25.441406 2.800781 C 25.390625 2.785156 25.347656 2.753906 25.347656 2.738281 C 25.347656 2.71875 25.265625 2.679688 25.160156 2.652344 C 25.058594 2.621094 24.972656 2.585938 24.972656 2.566406 C 24.972656 2.550781 24.820312 2.503906 24.628906 2.46875 C 24.320312 2.40625 23.429688 2.402344 14.960938 2.402344 C 6.527344 2.402344 5.601562 2.410156 5.308594 2.46875 C 5.125 2.503906 4.96875 2.550781 4.957031 2.566406 C 4.945312 2.585938 4.863281 2.621094 4.769531 2.652344 C 4.679688 2.679688 4.59375 2.71875 4.582031 2.730469 C 4.570312 2.746094 4.457031 2.824219 4.328125 2.910156 C 3.996094 3.128906 3.460938 3.679688 3.460938 3.808594 C 3.460938 3.832031 3.441406 3.859375 3.425781 3.859375 C 3.40625 3.859375 3.320312 4.003906 3.238281 4.183594 C 2.953125 4.800781 2.960938 4.554688 2.960938 11.207031 C 2.960938 15.953125 2.972656 17.175781 3.011719 17.175781 C 3.039062 17.175781 3.128906 17.082031 3.210938 16.976562 Z M 6.546875 9.53125 C 6.539062 9.5 6.511719 9.476562 6.480469 9.476562 C 6.394531 9.476562 6.210938 9.25 6.179688 9.109375 C 6.164062 9.035156 6.136719 8.964844 6.117188 8.953125 C 6.070312 8.921875 6.070312 6.289062 6.117188 6.195312 C 6.140625 6.160156 6.179688 6.066406 6.207031 5.996094 C 6.230469 5.921875 6.304688 5.8125 6.371094 5.75 C 6.53125 5.601562 6.867188 5.5625 8.03125 5.574219 C 8.527344 5.578125 12.160156 5.59375 16.109375 5.605469 L 23.289062 5.625 L 23.410156 5.71875 C 23.472656 5.769531 23.566406 5.878906 23.613281 5.96875 C 23.699219 6.121094 23.703125 6.164062 23.703125 7.617188 C 23.703125 8.558594 23.6875 9.113281 23.664062 9.132812 C 23.636719 9.152344 23.59375 9.21875 23.558594 9.285156 C 23.523438 9.351562 23.453125 9.421875 23.40625 9.445312 C 23.351562 9.472656 23.308594 9.503906 23.308594 9.519531 C 23.308594 9.539062 23.265625 9.5625 23.214844 9.570312 C 23.164062 9.578125 19.398438 9.589844 14.84375 9.582031 C 8.261719 9.578125 6.5625 9.566406 6.546875 9.53125 Z M 6.546875 9.53125 "
                  />
                </g>
              </svg>
            </AppLogo>
          </Link>
          { /* These tooltips will be displayed when the app tour is skipped on the landing page */ }
          {tourSkipped ? 
            <CustomTooltip title={t(NAVIGATION_MENUS.MENU_TOOLTIP_TEXT.key, NAVIGATION_MENUS.MENU_TOOLTIP_TEXT.value)} purpleColor sideNav>
              <SideNavButton drawVisible={drawVisible} showDraw={showDraw} hideDraw={hideDraw} />
            </CustomTooltip> 
          : <SideNavButton drawVisible={drawVisible} showDraw={showDraw} hideDraw={hideDraw} />}
          { /* Tooltip for Zoho Support widget */ }
          {tourSkipped && document.getElementById('pdsSupportWidget') && <CustomTooltip title={t(NAVIGATION_MENUS.SUPPORT_TOOLTIP_TEXT.key, NAVIGATION_MENUS.SUPPORT_TOOLTIP_TEXT.value)} widget sideNav /> }
          <div className="copy_right">
            <div style={{fontFamily:'Open Sans',fontWeight:'500'}}> © {APP_VERSION}</div>
            <div className="company">Perfect Doc Studio</div>
          </div>
        </GridItemContainer>
        {ssoSetup?.brandingEnabled && (
          <div className="patnerLogo">
            <div className="logo_1">
              <ImageWithFallback src="client-logo.png" className="image" />
            </div>
            <div className="logo">              
              <ImageWithFallback src="partner-logo.png" className="image" />
            </div>
          </div>
        )}
      </NavGridContainer>
      {modalVisibility && (
        <MultipleFileUploadModal
          visible={modalVisibility}
          onCancel={() => setmodalVisibility(false)}
        />
      )}
      <LogOutModal visible={ModalVisibility} OnCancel={() => setModalVisibility(false)} />
      {openPassword && <ChangePasswordModal visible={openPassword} onCancel={() => setOpenPassword(false)}/>}
      {showBillingModal && (
        <BillingPassword
          visible={showBillingModal}
          onCancel={() => setShowBillingModal(false)}
          isBillingModule={true}
        />
      )}
    </TopNavContainer>
  );
};
export default withTranslation(NAMESPACES)(SideNav);
